/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line

  // The quick add panel (api-product-upsell) is injected via innerHTML, so
  // Flickity's data-flickity auto-init never sees the sibling carousel.
  // theme:quick-add:open fires from MicroModal onShow on every open and
  // sibling swap, once the panel is visible and measurable.
  document.addEventListener('theme:quick-add:open', () => {
    if (!window.Flickity) return;

    requestAnimationFrame(() => {
      document.querySelectorAll('[data-quick-add-modal] [data-flickity]').forEach((carousel) => {
        if (window.Flickity.data(carousel)) return;

        let options = {};
        try {
          options = JSON.parse(carousel.getAttribute('data-flickity')) || {};
        } catch (e) {}

        new window.Flickity(carousel, options);
      });
    });
  });






  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function readMore(productId) {
  var element = productId
    ? document.getElementById("moreLess-" + productId)
    : document.getElementById("moreLess");
  if (!element) return;
  element.classList.add("show-full-content");
}
function myFunction() {
  document.querySelector('.error').innerHTML = "Please select a size above";
}

document.querySelectorAll('.quick-add__holder').forEach(holder => {
  holder.addEventListener('click', () => {
    console.log('Start: quick-add__holder clicked');

    let retries = 4;

    function tryInit() {
      const carousels = document.querySelectorAll('.carousel');
      console.log(`Found ${carousels.length} .carousel elements`);

      if (carousels.length === 0) {
        console.log('No carousel found. Finish.');
        if (retries-- > 0) {
          setTimeout(tryInit, 500);
        } else {
          console.log('No carousel found. Finish.');
        }
        return;
      }

      let initialized = false;

      carousels.forEach((carousel, index) => {
        if (carousel.classList.contains('flickity-enabled')) {
          console.log(`Carousel ${index} already initialized, skipping`);
          return;
        }

        const rect = carousel.getBoundingClientRect();
        const isVisible = (
          rect.width > 0 &&
          rect.height > 0 &&
          rect.top < window.innerHeight &&
          rect.bottom > 0
        );

        console.log(`Carousel ${index} visible: ${isVisible}`);

        if (isVisible) {
          console.log(`Initializing Flickity for carousel ${index}`);
          new Flickity(carousel, {
            cellAlign: 'left',
            contain: false,
            pageDots: false,
            prevNextButtons: true,
            groupCells: 4
          });
          initialized = true;
        }
      });

      if (!initialized && retries-- > 0) {
        setTimeout(tryInit, 500);
      } else {
        console.log('Finish: carousel init complete');
      }
    }

    tryInit();
  });
});

if (window.location.href.includes('/collections/')) {
  document.addEventListener('DOMContentLoaded', () => {
    const tooltips = document.querySelectorAll('.tooltip-custom');

    tooltips.forEach(tooltip => {
      // tooltip.addEventListener('mouseover', () => {
      //   if (window.innerWidth > 768) {
      //     tooltip.classList.add('show');
      //   }
      // });


      if (!localStorage.getItem('showTooltipMobile')) {
        tooltip.classList.add('show');
      }

      const closeButton = tooltip.querySelector('.tooltiptext-close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          tooltip.classList.remove('show');
        });
      }
    });

    localStorage.setItem('showTooltipMobile', 'true');

    window.disableAnimate = true;
    if (window.disableAnimate) return;

    // Animation control variables
    let animationStopped = false;
    let activeTimeouts = [];
    let activeIntervals = [];

    // Function to stop all animations
    const stopAllAnimations = () => {
      animationStopped = true;
      // Clear all active timeouts and intervals
      activeTimeouts.forEach(timeout => clearTimeout(timeout));
      activeIntervals.forEach(interval => clearInterval(interval));
      activeTimeouts = [];
      activeIntervals = [];
    };

    // Add user interaction listeners to stop animations
    const addUserInteractionListeners = () => {
      // const events = ['click', 'touchstart', 'scroll', 'keydown', 'mousemove'];

      // events.forEach(event => {
      //   document.addEventListener(event, stopAllAnimations, { once: true, passive: true });
      // });
    };

    // Enhanced function to wait for all resources to be fully loaded
    const waitForAllResourcesReady = (selector, maxAttempts = 20) => {
      return new Promise((resolve, reject) => {
        let attempts = 0;

        const checkResources = () => {
          attempts++;
          const slider = document.querySelector(selector);

          if (slider) {
            const flkty = Flickity.data(slider);
            if (flkty) {
              // Check if all images in the slider are loaded
              const images = slider.querySelectorAll('img');
              const allImagesLoaded = Array.from(images).every(img => {
                const isLoaded = img.complete &&
                  img.naturalHeight !== 0 &&
                  img.naturalWidth !== 0 &&
                  !img.src.includes('data:') && // Skip placeholder images
                  img.src !== '';

                return isLoaded;
              });

              // Check if Flickity is fully initialized and ready
              const flickityReady = flkty.isComplete !== false &&
                flkty.cells &&
                flkty.cells.length > 0;

              // Check if fonts are loaded
              const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

              if (allImagesLoaded && flickityReady) {
                console.log(`Resources ready for ${selector}:`, {
                  images: images.length,
                  allImagesLoaded,
                  flickityReady,
                  attempts
                });

                // Wait for fonts and any remaining resources
                fontsReady.then(() => {
                  // Small additional delay to ensure everything is settled
                  setTimeout(() => {
                    resolve(flkty);
                  }, 200);
                });
                return;
              } else {
                console.log(`Resources not ready for ${selector}:`, {
                  images: images.length,
                  allImagesLoaded,
                  flickityReady,
                  attempts
                });
              }
            }
          }

          if (attempts >= maxAttempts) {
            console.log(`Max attempts reached for ${selector}, using fallback`);
            // Fallback: resolve even if not perfect to avoid infinite waiting
            const slider = document.querySelector(selector);
            const flkty = slider ? Flickity.data(slider) : null;
            if (flkty) {
              resolve(flkty);
            } else {
              reject(new Error(`Slider not ready after ${maxAttempts} attempts`));
            }
            return;
          }

          // Wait a bit longer and try again
          setTimeout(checkResources, 200);
        };

        checkResources();
      });
    };

    const handleAnimationSlide = (selector, delay = 0) => {
      return new Promise((resolve) => {
        if (animationStopped) {
          resolve();
          return;
        }

        const delayTimeout = setTimeout(async () => {
          if (animationStopped) {
            resolve();
            return;
          }

          try {
            console.log(`Starting resource check for ${selector}`);
            // Wait for all resources to be fully loaded
            const flkty = await waitForAllResourcesReady(selector);

            if (animationStopped) {
              resolve();
              return;
            }

            console.log(`Resources loaded, starting animation for ${selector}`);

            // Additional delay to ensure smooth animation start
            setTimeout(() => {
              if (animationStopped) {
                resolve();
                return;
              }

              // Single animation cycle (next then previous)
              flkty.next(true);
              const nextTimeout = setTimeout(() => {
                if (animationStopped) {
                  resolve();
                  return;
                }

                flkty.previous(true);
                const prevTimeout = setTimeout(() => {
                  console.log(`Animation completed for ${selector}`);
                  resolve(); // Animation completed
                }, 500);
                activeTimeouts.push(prevTimeout);
              }, 500);
              activeTimeouts.push(nextTimeout);
            }, 300); // Additional delay for smoother animation

          } catch (error) {
            console.warn(`Resource loading failed for ${selector}:`, error);
            // If waiting fails, resolve to avoid blocking the sequence
            resolve();
          }
        }, delay);
        activeTimeouts.push(delayTimeout);
      });
    };

    // Create intersection observer to trigger animations when products come into view
    const observeProductAnimations = () => {
      const firstProduct = document.querySelector('.product-item:nth-child(1)');
      const secondProduct = document.querySelector('.product-item:nth-child(2)');

      if (!firstProduct && !secondProduct) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const productIndex = entry.target.classList.contains('product-item') ?
            Array.from(entry.target.parentNode.children).indexOf(entry.target) + 1 : 0;

          if (productIndex === 1) {
            console.log('Product in viewport, waiting for resources to load...');

            // Add user interaction listeners to stop animations
            addUserInteractionListeners();

            // Wait longer for page resources to be fully loaded
            setTimeout(() => {
              if (animationStopped) return;

              console.log('Starting animation sequence after resource wait');

              // Check if mobile device
              if (window.innerWidth < 768) {
                console.log('Mobile: Starting alternating animations');
                // Mobile: Alternating sequence - Slider1, Slider2, Slider1, Slider2
                handleAnimationSlide('.product-item:nth-child(1) .product-card-images-slider.flickity-enabled')
                  .then(() => {
                    if (secondProduct && !animationStopped) {
                      return handleAnimationSlide('.product-item:nth-child(2) .product-card-images-slider.flickity-enabled');
                    }
                  })
                  // .then(() => {
                  //   if (!animationStopped) {
                  //     // Second round - Slider 1 again
                  //     return handleAnimationSlide('.product-item:nth-child(1) .product-card-images-slider.flickity-enabled');
                  //   }
                  // })
                  // .then(() => {
                  //   if (secondProduct && !animationStopped) {
                  //     // Second round - Slider 2 again
                  //     return handleAnimationSlide('.product-item:nth-child(2) .product-card-images-slider.flickity-enabled');
                  //   }
                  // });
              } else {
                console.log('Desktop: Starting sequential animations');
                // Desktop: Original behavior - Slider1 twice, then Slider2
                handleAnimationSlide('.product-item:nth-child(1) .product-card-images-slider.flickity-enabled')
                  .then(() => {
                    if (!animationStopped) {
                     // return handleAnimationSlide('.product-item:nth-child(1) .product-card-images-slider.flickity-enabled');
                    }
                  })
                  // .then(() => {
                  //   if (secondProduct && !animationStopped) {
                  //     return handleAnimationSlide('.product-item:nth-child(2) .product-card-images-slider.flickity-enabled');
                  //   }
                  // });
              }
            }, 2500); // Increased wait time to 2.5 seconds for better resource loading

            // Stop observing after first trigger
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1, // Trigger when 10% of the element is visible
        rootMargin: '0px 0px -50px 0px' // Trigger slightly before element fully enters viewport
      });

      // Observe the first product item
      if (firstProduct) {
        observer.observe(firstProduct);
      }
    };

    // Initialize the intersection observer
    observeProductAnimations();

  });
}

